// extracted by mini-css-extract-plugin
export default {"contact-icon":"contactIcon_contact-icon__iu0hg"};